import axios from 'axios';

/*
*  axios calls for campaign lock related operations
*/

export const updateLockForFunnel = (funnelId, locked) => {
    return axios.put(`/app/funnel/${funnelId}/lock`, { locked });
};
